import * as React from "react"
import "../../styles/global.css";
import "../../styles/sunchaser.css";
import Font1 from "../../../static/fonts/jost-all-300-normal.woff";
import Font2 from "../../../static/fonts/jost-all-500-normal.woff";
import logoSunChaser from "../../../static/images/Sun Chaser logo v1.2.svg";
import logoApple from "../../../static/images/logo-apple.svg";
import logoGoogle from "../../../static/images/logo-google.png";
import screenshot1 from "../../../static/images/Sydney.webp";
import screenshot2 from "../../../static/images/Melbourne.webp";
import screenshot3 from "../../../static/images/Suburb.webp";
import { OutboundLink } from "gatsby-plugin-gtag"
import { Helmet } from "react-helmet";

// markup
const IndexPage = () => {
	return (
		<>
			<Helmet>
				<title>Sun Chaser</title>
				<meta name="description" content="Sun Chaser is a new app that provides sunrise/sunset forecasts for all of Australia based on a cutting-edge algorithm." />
				<link rel="preload" as="font" type="font/woff" crossOrigin="anonymous" href={Font1} />
				<link rel="preload" as="font" type="font/woff" crossOrigin="anonymous" href={Font2} />
			</Helmet>
			<main className="sc-main">
				<div className="frame" id="frame-scroll-sc">
					<div className="frame" id="frame-top">
						<div className="frame" id="frame-topleft">
							<a href="/sunchaser/">
								<img src={logoSunChaser} id="logo-sunchaser" alt="Sun Chaser logo" />
							</a>
							<OutboundLink target="_blank" href="/040892">
								<img src={logoApple} id="logo-apple" className="logo-appstore" alt="Apple App Store logo" />
							</OutboundLink>
							<OutboundLink target="_blank" href="/0b98d2">
								<img src={logoGoogle} id="logo-google" className="logo-appstore" alt="Google Play Store logo" />
							</OutboundLink>
						</div>
						<div className="frame" id="frame-topright">
							<div className="content-main">
								<div className="sc-heading">Catch The Sun</div>
								<p className="sc-p">Find out when you'll see the next beautiful sunrise or sunset where you are. Works for all Australian locations!</p>
								<p className="sc-p">Sun Chaser is powered by a cutting edge algorithm processing millions of data points daily. Forecasts are updated every six hours.</p>
							</div>
						</div>
					</div>
					<div className="frame" id="frame-middle">
						<img src={screenshot1} className="sc-screenshot" alt="A screenshot of the Sun Chaser app" />
						<img src={screenshot2} className="sc-screenshot" alt="A screenshot of the Sun Chaser app" />
						<img src={screenshot3} className="sc-screenshot" alt="A screenshot of the Sun Chaser app" />
					</div>
					<div className="frame" id="frame-footer">
						<div id="footer">Copyright (c) 2022 Earthrise Tech. App Store and the App Store logo are trademarks of Apple Inc. Google Play and the Google Play logo are trademarks of Google LLC.</div>
					</div>
				</div>
			</main>
		</>
	)
}

export default IndexPage
